import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_16167_12586)">
      <path
        d="M8.00003 15.1426C11.9449 15.1426 15.1429 11.9447 15.1429 7.99979C15.1429 4.0549 11.9449 0.856934 8.00003 0.856934C4.05514 0.856934 0.857178 4.0549 0.857178 7.99979C0.857178 11.9447 4.05514 15.1426 8.00003 15.1426Z"
        fill="#070F21"
        stroke="white"
      />
      <path
        d="M11.4234 7.71436V8.28578M7.99989 7.71436V8.28578M4.57642 7.71436V8.28578"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16167_12586">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconMenuDots = memo(ForwardRef);
export default IconMenuDots;
